<main class="elab-container">
  <app-general-message></app-general-message>
  <app-header *ngIf="displayComponent"></app-header>
  <router-outlet></router-outlet>
  <app-loading-spinner></app-loading-spinner>
  <app-footer *ngIf="displayComponent"></app-footer>
  <app-authentication></app-authentication>
</main>
